import { render, staticRenderFns } from "./QuotationForm.vue?vue&type=template&id=0a3dd5d9&scoped=true"
import script from "./QuotationForm.vue?vue&type=script&lang=js"
export * from "./QuotationForm.vue?vue&type=script&lang=js"
import style0 from "./QuotationForm.vue?vue&type=style&index=0&id=0a3dd5d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3dd5d9",
  null
  
)

export default component.exports